module.exports = __webpack_public_path__ + "static/media/48373067_2308756579199520_5082708441760268288_o.f9d7fbd0.jpg";